var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 0C3.50368 0 3 0.50368 3 1.125V3H1.125C0.50368 3 0 3.50368 0 4.125V10.875C0 11.4963 0.503679 12 1.125 12H7.875C8.49632 12 9 11.4963 9 10.875V9H10.875C11.4963 9 12 8.49632 12 7.875V1.125C12 0.50368 11.4963 0 10.875 0H4.125ZM9 8.25H10.875C11.0821 8.25 11.25 8.08211 11.25 7.875V1.125C11.25 0.917893 11.0821 0.75 10.875 0.75H4.125C3.91789 0.75 3.75 0.917893 3.75 1.125V3H7.875C8.49632 3 9 3.50368 9 4.125V8.25ZM0.75 4.125C0.75 3.91789 0.917893 3.75 1.125 3.75H7.875C8.08211 3.75 8.25 3.91789 8.25 4.125V10.875C8.25 11.0821 8.08211 11.25 7.875 11.25H1.125C0.917893 11.25 0.75 11.0821 0.75 10.875V4.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.b2a5cbf98dd8807a05ed36b7481751e2.svg";
export { ForwardRef as ReactComponent };